import { initInstallationSpecSection } from './pro-multifamily-installation-specifications/pro-multifamily-installation-specifications';
import VerticalCarriage from '../../scripts/components/VerticalCarriage';
import { activateTabs } from './pro-multifamily-installation-support/pro-multifamily-installation-support';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';

const { onReady } = window;

onReady(() => {
  initInstallationSlider();
  initInstallationSpecSection();
  activateTabs();

  VerticalCarriage.init(
    document.querySelector('[data-pro-multifamily-installation-support-tabs]')
  );
});
